import { useSelector } from 'react-redux';
import { DESKTOP, TABLET } from '../state/actions/constants/app.constants';


export const useBreakpoint = () => {
  const breakPoint = useSelector((state: any) => state.app.breakPoint);
  return { isTablet: breakPoint === TABLET, isDesktop: breakPoint === DESKTOP };
};
